import React from "react";
import { Facebook, Instagram, Youtube } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative bg-[#111111] text-white font-inter border-t border-white/10">
      <div className="mx-auto max-w-[92rem] px-5 sm:px-8 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="space-y-4">
            <h3 className="font-sharetech text-xl font-bold">SOLARES</h3>
            <p className="text-white/70 text-sm leading-relaxed">
              Powering Filipino homes with clean energy since 2025. Premium solar systems engineered for reliability.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold mb-4 text-solar-gold">Quick Links</h4>
            <ul className="space-y-2 text-sm text-white/70">
              <li><a href="/" className="hover:text-solar-gold transition">Home</a></li>
              <li><a href="/products" className="hover:text-solar-gold transition">Products</a></li>
              <li><a href="/projects" className="hover:text-solar-gold transition">Projects</a></li>
              <li><a href="#contacts" className="hover:text-solar-gold transition">Contact</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-bold mb-4 text-solar-gold">Legal</h4>
            <ul className="space-y-2 text-sm text-white/70">
              <li><span className="cursor-pointer hover:text-solar-gold transition">Privacy Policy</span></li>
              <li><span className="cursor-pointer hover:text-solar-gold transition">Terms of Service</span></li>
              <li><span className="cursor-pointer hover:text-solar-gold transition">Warranty Info</span></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold mb-4 text-solar-gold">Contact</h4>
            <ul className="space-y-2 text-sm text-white/70">
              <li>
                <a href="tel:+63-961-121-2003" className="hover:text-solar-gold transition">
                  +63 961 121 2003
                </a>
              </li>
              <li>
                <a href="mailto:solares.energysolutions@gmail.com" className="hover:text-solar-gold transition">
                  solares.energysolutions@gmail.com
                </a>
              </li>
              <li>Philippines</li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-solar-border mb-8" />

        {/* Bottom */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <p className="text-sm text-white/70">
            © 2025 <span className="font-bold text-white">SOLARES</span>. All rights reserved.
          </p>

          {/* Social Links */}
          <div className="flex gap-4">
            <button
              className="h-10 w-10 rounded-full bg-white/10 hover:bg-solar-gold/20 flex items-center justify-center transition"
              aria-label="Facebook"
            >
              <Facebook size={18} />
            </button>
            <button
              className="h-10 w-10 rounded-full bg-white/10 hover:bg-solar-gold/20 flex items-center justify-center transition"
              aria-label="Instagram"
            >
              <Instagram size={18} />
            </button>
            <button
              className="h-10 w-10 rounded-full bg-white/10 hover:bg-solar-gold/20 flex items-center justify-center transition"
              aria-label="YouTube"
            >
              <Youtube size={18} />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
